import { ErrorContent } from '../../components/layouts'

export default function RequestError() {
  return <ErrorContent
    title='Request Error'
    subtitle='サーバーへのリクエスト時にエラーが発生しました'
    message='前のページに戻って操作をやり直してください。'
    returnToBefore={true} />
}
